import styled from 'styled-components';

interface IDnDCard {
    blocked?: boolean;
    outStock?: boolean;
    className?: string;
    isDragging: boolean;
}

export const DnDCard = styled.div<IDnDCard>` 
    display: flex;
    width: 100%;
    box-sizing:border-box;
    opacity: 1;
    
    > div {
        width: 100%;
        opacity: ${props => props.isDragging ? .6 : 1};
        border: ${props => props.isDragging ? '2px dashed rgba(0, 135, 73, .5)' : 'transparent'};
        cursor: ${props => props.isDragging ? 'grabbing' : props.blocked ? 'not-allowed' : 'grab'};
    }
    
    &.background-row:nth-child(odd) > div > div {
        width: 100%;
        background-color: rgba(98,92,92,0.1);
    }
    
    &.background-row:nth-child(even) > div > div {
        width: 100%;
        background-color: #fff;
    }
    
    &.background-row:first-child  > div > div {
        width: 100%;
        background-color:${props => props.outStock ? '#FFE3E3' : '#D0DEE1'} !important;
    }
    
    .icon{
        transition: all 1s ease-in;

        img{
            display: ${props => props.isDragging ? 'initial' : 'none'};            
        }
    }

    &:hover{
        img{
            display: initial;
        }        
    }
`;
